import Login from './components/Login.vue'

const l = new Vue({
    el: '#login',
    render: h => h(Login),
});


// WEBPACK FOOTER //
// ./resources/assets/js/login.js